import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        min_height: '188px',
        border_width: FOUNDATIONS.border_100,
        border_style: 'dashed',
        border_radius: FOUNDATIONS.radius_comp_forms_inputsignature_radiussize,
        width: '100%',
        position: 'relative',
        background_color: FOUNDATIONS.color_comp_forms_input_bg,
        ...STATE_TOKENS.container,
    },
    placeholderContainer: {
        padding: `${FOUNDATIONS.spacing_350} ${FOUNDATIONS.spacing_250}`,
        position: 'absolute',
        display: 'flex',
        justify_content: 'center',
        align_items: 'center',
        top: '0',
        left: '0',
        height: '100%',
        width: '100%',
    },
    placeholderText: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: Number(FOUNDATIONS.font_weight_paragraph_small_regular),
        color: FOUNDATIONS.color_comp_forms_input_empty_font,
        ...STATE_TOKENS.placeholderText,
    },
});
//# sourceMappingURL=commonStyles.js.map